import { Box, Divider, Grid, Typography } from "@material-ui/core"
import React, { useCallback, useMemo } from "react"
import { ItemSacola } from "storage"
import { useStyles } from "./pedido-valores-styles"
import { usePedidos } from "services/providers/pedidos-provider"
import { EnumPagTpMod } from "models/enums/enum-pag-tpmod"

export const PedidoValores = () => {
    const classes = useStyles()
    const { getItensSacola, getItemEntrega, transacao } = usePedidos()

    // PRODUTO ENTREGA
    const itensSacola = useMemo(() => (getItensSacola() || ([] as ItemSacola[])), [getItensSacola])
    const itemEntrega = getItemEntrega()
    const itensSacolaProduto = itensSacola.filter(x => x.produtoId !== itemEntrega?.produtoId)

    const valorItemEntrega = itemEntrega?.vFinal || 0

    const subTotal = useCallback(() => {
        let valor =
            itensSacolaProduto.length > 0
                ? itensSacolaProduto.filter(x => x.indFin).map((item) => {

                    if (item.vUnCom === 0) {
                        return 0;
                    }
                    return item.vUnCom * (item.qComModificador > 0 ? item.qComModificador : item.qCom) + item.vAcrescUsuario - item.vDescUsuario
                }).reduce((prev, next) => prev + next, 0)
                : 0;

        return (valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }, [itensSacolaProduto]);

    const total = useCallback(() => {
        let valorItens =
            itensSacolaProduto.length > 0
                ? itensSacolaProduto.filter(x => x.indFin).map((item) => {

                    if (item.vUnCom === 0) {
                        return 0;
                    }
                    return item.vUnCom * (item.qComModificador > 0 ? item.qComModificador : item.qCom) + item.vAcrescUsuario - item.vDescUsuario
                }).reduce((prev, next) => prev + next, 0)
                : 0;
        const valorTotal = valorItens + valorItemEntrega;
        return (valorTotal || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }, [itensSacolaProduto, valorItemEntrega]);

    return (
        <Grid container className={classes.container}>
            <Grid item xs={12} container justify="space-between">
                <Typography variant="body2" color="textSecondary" className={classes.textoTitle}>
                    Subtotal
                </Typography>
                <Typography variant="body1" color="textPrimary" className={classes.textoSubTotais}>
                    {subTotal()}
                </Typography>
            </Grid>
            {itemEntrega && (
                <Grid item xs={12} container justify="space-between">
                    <Typography variant="body2" color="textSecondary" className={classes.textoTitle}>
                        Taxa de Entrega
                    </Typography>
                    <Typography variant="body1" color="textPrimary" className={classes.textoSubTotais}>
                        {valorItemEntrega > 0 && `${valorItemEntrega.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`}
                    </Typography>
                </Grid>
            )}
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} container justify="space-between">
                <Typography variant="h6" color="textPrimary" className={classes.textoTitleTotal}>
                    <Box component="span" fontWeight={500}>Total</Box>
                </Typography>
                <Typography variant="h6" color="textPrimary" className={classes.textoTotais}>
                    {total()}
                </Typography>
            </Grid>
            {transacao?.valorPago && transacao.valorPago > 0 && transacao.tpMod === EnumPagTpMod.DINHEIRO ?
                <Grid item xs={12} container justify="space-between">
                    <Typography variant="body2" color="textSecondary" className={classes.textoTitle}>
                        Pagamento:
                    </Typography>
                    <Typography variant="body1" color="textPrimary" className={classes.textoSubTotais}>
                        {transacao.valorPago > 0 && `${transacao.valorPago.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`}

                    </Typography>
                </Grid>
                : ''}
            {transacao?.valorTroco && transacao.valorTroco > 0 ?
                <Grid item xs={12} container justify="space-between">
                    <Typography variant="body2" color="textSecondary" className={classes.textoTitle}>
                        Troco
                    </Typography>
                    <Typography variant="body1" color="textPrimary" className={classes.textoSubTotais}>
                        {transacao.valorTroco > 0 && `${transacao.valorTroco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`}

                    </Typography>
                </Grid>
                : ''}
        </Grid>
    )
}